import { StyledModal } from '@app/components/modal/Modal';
import useBrandActions from '@app/hooks/brands/useBrandActions';
import type { Brand } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { BrandForm } from './BrandForm';

export type BrandAddModalProps = ModalProps & {
    title?: string;
    data?: Brand;
};

export const BrandAddModal = ({
    title = 'New Brand',
    data,
    onOk,
    ...props
}: BrandAddModalProps) => {
    const { addBrand } = useBrandActions();

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    return (
        <StyledModal title={title} mask={{ closable: false }} width={680} footer={null} {...props}>
            <BrandForm
                id="brand-add"
                data={data}
                isEdit={false}
                onCancel={props.onCancel}
                loading={addBrand.isPending}
                onSubmit={(values) => {
                    const formData = {
                        ...values,
                    };
                    addBrand.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
